module.exports = __webpack_public_path__ + "media/slide1/contractMediaSlide1Part1-5523d002.png";